import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "../../../../style/Dentisstyle.css";
import "../../../../style/addmaterial.css";
import "../../../../style/userloginhistory.css";
import { apiAxios } from "../../../../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const UserLoginHistory: React.FC = () => {
  const [histories, setHistories] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [username, setUsername] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<string>("");

  const formatDateTime = (dateString: string) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const conditionalRowStyles = [
    {
      when: (row: any) => row._idx % 2 === 0,
      style: { backgroundColor: "#ffffff" },
    },
    {
      when: (row: any) => row._idx % 2 !== 0,
      style: { backgroundColor: "#f9f9f9" },
    },
  ];
  const fetchUsers = async () => {
    try {
      const response = await apiAxios.get(`${API_BASE}/Users/GetUsers`);
      setUsers(response.data);
    } catch (error) {
      console.error("User fetch error:", error);
    }
  };

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchHistories = async () => {
    try {
      setLoading(true);

      const payload = {
        UserName: selectedUser || null,
        StartDate: startDate ? formatDate(startDate) : null,
        EndDate: endDate ? formatDate(endDate) : null,
      };

      const response = await apiAxios.post(
        `${API_BASE}/Auth/GetUserLoginHistory`,
        payload
      );

      setHistories(response.data);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchHistories();
  };

  const handleClear = () => {
    setSelectedUser("");
    setStartDate(null);
    setEndDate(null);
    setHistories([]);
  };

  const columns = [
    {
      name: "Username",
      selector: (row: any) => row.name,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row: any) => row.roleName || "No Role",
      sortable: true,
      cell: (row: any) => (
        <span
          style={{
            backgroundColor: "#007bff",
            color: "white",
            padding: "4px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "500",
          }}
        >
          {row.roleName || "No Role"}
        </span>
      ),
    },
    {
      name: "Login Time",
      selector: (row: any) => formatDateTime(row.loginTime),
      sortable: true,
    },
    {
      name: "Logout Time",
      selector: (row: any) => formatDateTime(row.logoutTime),
      sortable: true,
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        fontSize: "14px",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        justifyContent: "center",
      },
    },
  };

  return (
    <div>
      <h4 className="mb-4">User Login History</h4>
      <div className="premium-card mt-3">
        <div className="row py-3">
          <div className="col-md-4">
            <label className="form-label">User Name</label>
            <select
              className="form-control user-name-select"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value="">All Users</option>
              {users.map((user) => (
                <option key={user.userID} value={user.name}>
                  {user.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 position-relative">
            <label className="form-label">Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control"
              portalId="root-datepicker"
              dateFormat="dd-MM-yyyy"
              maxDate={new Date()}
            />
            <i
              className="bi bi-calendar3"
              style={{
                position: "absolute",
                right: "25px",
                top: "72%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#6c757d",
              }}
            ></i>
          </div>

          <div className="col-md-4 position-relative">
            <label className="form-label">End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              portalId="root-datepicker"
              className="form-control"
              dateFormat="dd-MM-yyyy"
              maxDate={new Date()}
            />
            <i
              className="bi bi-calendar3"
              style={{
                position: "absolute",
                right: "25px",
                top: "72%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#6c757d",
              }}
            ></i>
          </div>

          <div className="col-md-12 d-flex gap-2 mt-3">
            <button
              className="btn btn-primary updatebtncustom"
              onClick={handleSearch}
            >
              Search
            </button>

            <button
              className="btn btn-secondary user-login-history-btnclear"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div className="premium-card mt-3 ">
        <h5 className="mb-3">Uer Login History List</h5>
        <DataTable
          columns={columns}
          data={histories}
          pagination
          highlightOnHover
          striped
          persistTableHead
          progressPending={loading}
          noDataComponent="Click Search to view login history"
          customStyles={customStyles}
          conditionalRowStyles={conditionalRowStyles}
          className="admin-delivery-table"
        />
      </div>
    </div>
  );
};

export default UserLoginHistory;
